import { render, staticRenderFns } from "./sourcing-task.vue?vue&type=template&id=50b4fd9c&"
import script from "./sourcing-task.vue?vue&type=script&lang=js&"
export * from "./sourcing-task.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports